import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import {
  PipelineParams,
  PipelineParamsWithStage,
  PipelinePlacement,
  PipelineStage,
} from '@recruitee/http-types';
import { getOptions } from '@recruitee/walkthrough-utils';

import { defaultPipelineParams } from './consts';

@Injectable({ providedIn: 'root' })
export class PipelineStagesHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(
    id: string,
    params: PipelineParams = defaultPipelineParams,
  ): Observable<{ stages: PipelineStage[]; id: string }> {
    return this.httpApi
      .get(`/offers/${id}/placements`, params, getOptions({ hasOnboarding: true }))
      .pipe(
        map(response => ({
          stages: response.stages,
          id,
        })),
      );
  }

  public fetchStagePlacements$(
    id: string,
    params: PipelineParamsWithStage,
  ): Observable<PipelinePlacement[]> {
    return this.httpApi
      .get(`/offers/${id}/placements`, params)
      .pipe(map(response => response.placements));
  }

  public fetchPlacement(
    offerId: number,
    candidateId: number,
    params: PipelineParams = defaultPipelineParams,
  ): Observable<PipelinePlacement> {
    return this.httpApi
      .get(`/offers/${offerId}/candidates/${candidateId}/placement`, params)
      .pipe(map(response => response.placement));
  }
}
